module.exports = __webpack_public_path__ + "static/media/Income-tax-3.8802e019.png";